<template>
	<section class="form form__vertical">
		<form @submit.prevent="uploadFile" class="form__input flex-vertical">
			<div class="form__image-preview">
				<img v-if="!showCroppie" class="profile-photo profile-photo-image" :src="user.photoUrl" alt="" />

				<vue-croppie
					v-if="showCroppie"
					ref="croppie"
					customClass="profile-photo profile-photo-image"
					:enableResize="false"
					:viewport="{ width: 220, height: 220, type: 'circle' }"
				/>

				<input class="profile-photo profile-photo-input" type="file" name="profile_pic" accept="image/*" required @change="addPhoto" />
			</div>
			<div class="profile__controls">
				<v-button :loading="form.busy" class="mar__b-1 text-box-bottom" :disabled="!showCroppie">{{
					$t('profile.edit.upload_new_pic')
				}}</v-button>
				<span class="heading-caption">Můžeš použít fotku, nebo obrázek ve formátu JPG nebo PNG.</span>
			</div>
		</form>
	</section>
</template>

<script>
import Form from 'vForm'
import { mapGetters } from 'vuex'
export default {
	computed: {
		...mapGetters({
			user: 'auth/user',
		}),
	},

	data() {
		return {
			showCroppie: false,
			form: new Form({
				profile_pic: null,
			}),
		}
	},

	methods: {
		addPhoto(e) {
			let files = e.target.files || e.dataTransfer.files
			if (!files.length) return

			let reader = new FileReader()
			reader.onload = (e) => {
				this.$refs.croppie.bind({
					url: e.target.result,
				})
			}
			reader.readAsDataURL(files[0])
			this.showCroppie = true
		},
		async uploadFile() {
			if (!this.showCroppie) return
			let options = {
				type: 'blob',
				size: { width: 600, height: 600 },
				// format: 'jpeg'
			}

			await this.$refs.croppie.result(options, (output) => {
				this.form.profile_pic = output
			})

			let { data } = await this.form.post('/user/profile/photo', {
				transformRequest: [
					function (data) {
						var form_data = new FormData()
						for (var key in data) {
							form_data.append(key, data[key])
						}
						return form_data
					},
				],
			})
			this.$store.commit('auth/FETCH_USER_SUCCESS', data)
			this.showCroppie = false
		},
	},
}
</script>

<style lang="scss" scoped></style>
